import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

/**
 * Deliberate image treatment — clipped corner frame, 1px gold border,
 * slow internal parallax on scroll.
 */
export default function ParallaxFrame({ src, alt, className = "", caption, imgClassName = "" }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ["0%", "0%"] : ["-9%", "9%"]);
  return (
    <div
      ref={ref}
      className={`clip-frame relative overflow-hidden border border-[#C6A87C]/30 ${className}`}
    >
      <motion.img
        src={src}
        alt={alt}
        style={{ y }}
        className={`absolute -top-[10%] left-0 w-full h-[120%] object-cover ${imgClassName}`}
      />
      <div className="absolute inset-0 bg-navy/30 pointer-events-none" />
      {caption && (
        <div className="absolute bottom-0 inset-x-0 p-5 bg-gradient-to-t from-[#061324]/90 to-transparent">
          <div className="label-overline text-[#F5F4F0]/80">{caption}</div>
        </div>
      )}
    </div>
  );
}
